export const getReadableDate = (date: string) => {
  return date.substring(5, 10)
    .split('-')
    .reverse()
    .join('.')
}
